import Link from "gatsby-link";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";
import VisibilitySensor from "react-visibility-sensor";

import config from "../../../content/meta/config";
import Menu from "../Menu";

import avatar from "../../images/png/avatar.png";

const styles = theme => ({
  header: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    height: theme.header.height.default,
    position: "relative",
    width: "100%",
    "&.homepage": {
      position: "absolute",
      backgroundColor: "transparent",
      zIndex: 1
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {
      padding: `0 ${theme.spacing.L}px`
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      alignItems: "center",
      justifyContent: "space-between",
      display: "flex",
      height: theme.header.height.default,
      position: "absolute",
      top: 0,
      width: "100%",
      transition: "padding 0.5s",
      "&.fixed": {
        position: "fixed",
        backgroundColor: "white",
        zIndex: 1,
        left: 0,
        top: 0,
        width: "100%",
        padding: `0 ${theme.spacing.M}px`
      }
    }
  },
  avatarLink: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {},
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {}
  },
  avatar: {
    flexShrink: 0,
    display: "inline-block",
    "&.homepage": {
      display: "none"
    },
    height: 44,
    overflow: "hidden",
    width: 44,
    transition: "all 0.5s",
    "& img": {
      width: "100%"
    },
    [`@media (max-width: ${theme.mediaQueryTresholds.M - 1}px)`]: {
      paddingLeft: 8
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {},
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      width: "64px",
      height: "64px",
      "&.fixed": {
        display: "inline-block"
      }
    },
    "@media (hover: hover)": {
      "&:hover": {
        borderRadius: "75% 65%"
      }
    }
  },
  title: {
    display: "inline-block",
    "&.homepage": {
      display: "none"
    },
    paddingLeft: 8,
    [`@media (max-width: ${theme.mediaQueryTresholds.M - 1}px)`]: {
      display: "none"
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {},
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      "&.fixed": {
        display: "inline-block"
      }
    }
  },
  sensor: {
    display: "block",
    position: "absolute",
    bottom: 0,
    zIndex: 1,
    left: 0,
    right: 0,
    height: 1,
    top: theme.header.height.default
  },
  expand: {
    position: "absolute",
    top: "30px",
    right: "-25px",
    display: "none",
    color: theme.info.colors.text,
    ".is-aside.open &": {
      display: "block"
    }
  }
});

class Header extends React.Component {
  state = {
    fixed: false
  };

  visibilitySensorChange = val => {
    if (val) {
      this.setState({ fixed: false });
    } else {
      this.setState({ fixed: true });
    }
  };

  getHeaderSize = classes => {
    const fixed = this.state.fixed ? "fixed" : "";
    const homepage = this.props.path === "/" ? "homepage" : "";

    return `${fixed} ${homepage}`;
  };

  render() {
    const { pages, path, isWideScreen, classes } = this.props;
    const { fixed } = this.state;
    const isHomepage = path === "/";

    return (
      <React.Fragment>
        <header className={`${classes.header} ${this.getHeaderSize(classes)}`}>
          <Link to="/" className={classes.avatarLink} title={config.siteTitle}>
            <div className={`${classes.avatar} ${this.getHeaderSize(classes)}`}>
              <img src={avatar} />
            </div>
          </Link>
          <div className={`${classes.title} ${this.getHeaderSize(classes)}`}>
            Monika Bandelewska
          </div>
          <Menu
            path={path}
            isHomepage={isHomepage}
            fixed={fixed}
            isWideScreen={isWideScreen}
            isSubView={this.props.isSubView}
            pages={pages}
            onClickItem={this.props.scrollToContent}
          />
        </header>
        <VisibilitySensor onChange={this.visibilitySensorChange}>
          <div className={classes.sensor} />
        </VisibilitySensor>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  pages: PropTypes.array.isRequired,
  path: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  scrollToContent: PropTypes.func,
  isWideScreen: PropTypes.bool.isRequired,
  isSubView: PropTypes.bool
};

export default injectSheet(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js